import {Component} from "@angular/core";
import {DealEvents} from "../deal-events";
import {EntitlementStatus} from "../entitlement-entity.model";

@Component({
    selector: "woa-deal-summary-icon",
    templateUrl: "./deal-summary-icon.component.html"
})
export class DealSummaryIconComponent {
    EntitlementStatus = EntitlementStatus;
    DealEvents = DealEvents;
}



// WEBPACK FOOTER //
// ./src/app/deal/deal-summary-icon/deal-summary-icon.component.ts